var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.781 25.491c.096.09.157.218.157.36 0 .272-.22.493-.493.493-.142 0-.27-.06-.36-.157l-9.503-9.503-9.503 9.503c-.088.082-.206.132-.336.132-.272 0-.493-.22-.493-.493 0-.13.05-.248.133-.336l9.503-9.503-9.503-9.503c-.082-.088-.132-.206-.132-.336 0-.272.22-.493.493-.493.13 0 .248.05.336.133l9.503 9.503 9.503-9.503c.088-.082.206-.132.336-.132.272 0 .493.22.493.493 0 .13-.05.248-.133.336l-9.503 9.503z"
  })));
};
export default SvgClose;